'use client';

import Link from 'next/link';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';
import WaitlistWidget from 'src/components/WaitlistWidget';

import './page.scss';

export default function HomePage() {

  return (
    <div className="min-h-screen flex flex-col text-white bg-black selection:bg-white/20">


      {/* Main Content Area */}
      <main className="flex-grow flex flex-col ">
        {/* Hero Section */}
        <div 
          className="relative flex flex-col text-center min-h-[calc(100vh-400px)] md:min-h-[100vh] md:pt-40 bg-cover bg-center bg-no-repeat hero-section-background"
        >
          {/* Overlays Container */}
          <div className="absolute inset-0">
            {/* <div className="absolute inset-0 hero-gridlines"></div> */}
            <div className="absolute inset-0 hero-haze-layer"></div>
            <div className="absolute inset-0 hero-pattern-overlay"></div>
          </div>

          {/* Hero Content Container */}
          <div className="relative z-10 flex flex-col items-center justify-center md:justify-start px-4 sm:px-6 lg:px-8 py-16 flex-grow">
            {/* Mobile-optimized branding */}
            <div className="flex flex-col justify-center items-center mb-8">
              {/* <MiraLogoOnly className=" h-8 w-auto text-white mb-2 md:mb-4" /> */}
              <img src="/mira-logo.svg" alt="Mira Verify - Autonomous AI Verification Platform Logo" className=" pr-4 md:pr-10 mb-2 md:mb-4"  />
              <div className="flex items-center justify-center space-x-2">
                <span className="text-lg md:text-2xl font-medium tracking-widest text-white">MIRA VERIFY</span>
                <span className=" text-blue-200 px-2 py-0.5 rounded-full text-xs font-medium tracking-wider border border-blue-400/50">
                  beta
                </span>
              </div>
            </div>

            <h1 style={{ fontFamily: 'GT Super Display' }} className="text-[44px] md:text-5xl lg:text-6xl font-none mb-6 text-white shadow-sm">
              Build<br className="md:hidden" /> Autonomous<br/>AI Today
            </h1>
            <p className="text-base md:text-lg text-gray-300 mb-8 max-w-2xl mx-auto leading-relaxed">
            Build confidently with AI that delivers factual, reliable outputs without human review. The Mira Verify API saves you time and money by having multiple AI models cross-check each other&apos;s work, enabling autonomous applications that weren&apos;t possible before.
            </p>
            
            {/* Waitlist Section */}
            <div className="mt-16 mb-20 w-full max-w-xl mx-auto px-4 relative">
              {/* Subtle background blur */}
              <div className="absolute inset-0 -inset-x-10 -inset-y-4 bg-gradient-to-r from-white/5 via-white/10 to-white/5 blur-2xl -z-10"></div>
              
              <div className="relative bg-black/40 backdrop-blur-sm border border-white/10 rounded-lg p-8">
                <div className="text-center mb-6">
                  <h2 className="text-xl sm:text-2xl font-semibold text-white mb-2">
                    Get Early Access
                  </h2>
                  <p className="text-gray-400 text-sm">
                    Be the first to build autonomous AI applications
                  </p>
                </div>
                
                <WaitlistWidget />
              </div>
            </div>
            
            {/* Feature Grid */}
            <div className="flex items-center justify-center">
          <div className="max-w-7xl mx-auto relative">
          <div className="absolute inset-0 hero-gradient-overlay"></div>
          {/* Grid changes for better mobile appearance */}
            <div className="grid grid-cols-1 text-start md:grid-cols-4 border border-white/20 relative z-10">
              {/* Feature 1 - Added bg-black for mobile */}
              <div className="bg-black md:bg-transparent text-gray-300 p-6 md:p-8 border-b md:border border-white/60">
                <h3 className="font-semibold text-white mb-2 text-sm">Free Your Team from AI Babysitting</h3>
                <p className="text-xs pt-2 md:pt-4 text-gray-400">Automated verification means no more manual review.</p>
              </div>
              {/* Feature 2 - Added bg-black for mobile */}
              <div className="bg-black md:bg-transparent text-gray-300 p-6 md:p-8 border-b  md:border border-white/60">
                <h3 className="font-semibold text-white mb-2 text-sm">Build Truly Autonomous AI</h3>
                <p className="text-xs pt-2 md:pt-4 text-gray-400">Create applications that work without human intervention.</p>
              </div>
              {/* Feature 3 - Added bg-black for mobile */}
                <div className="bg-black md:bg-transparent text-gray-300 p-6 md:p-8 border-b  md:border border-white/60">
                <h3 className="font-semibold text-white mb-2 text-sm">Trustworthy by Design</h3>
                <p className="text-xs pt-2 md:pt-4 text-gray-400">Audit every verification from input to consensus.</p>
              </div>
              {/* Links section - full coverage boxes */}
              <div className="flex flex-col justify-stretch h-full">
                <div className="bg-white rounded-none flex-1">
                  <Link href="/app" className="block text-black hover:text-gray-700 group text-sm font-medium flex items-center justify-between px-6 py-4 h-full">
                    <div>
                      <span>Verify Claims</span>
                      <div className="text-xs text-gray-600 mt-0.5">For registered users</div>
                    </div>
                    <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </Link>
                </div>
                <div className="bg-black rounded-none flex-1 border border-white/50">
                  <Link href="https://mira.network" target="_blank" className="block text-white hover:text-gray-300 group text-sm font-medium flex items-center justify-between p-6 h-full">
                    <span>About Mira</span>
                    <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
          </div>
                  {/* Content of the new feature bar will go here */}

        </div>

        {/* How Mira Verify Works Section */}
        <section className="bg-black hero-gridlines border-b border-white/40 py-12 md:py-16 relative overflow-hidden">
          <div className="absolute inset-0 hero-gridlines-right z-0 pointer-events-none"></div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <h2 style={{ fontFamily: 'GT Super Display' }} className="text-center text-3xl md:text-4xl mb-10 md:mb-16">
              How Mira Verify Works
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-0">
              {/* Left Column - Verify Everything */}
              <div className="md:border-r border-white/20 pr-0 md:pr-8">
                <div className="mb-8">
                  <Image 
                    src="/img1.png"
                    width={800} 
                    height={600} 
                    alt="Mira Verify interface showing AI-powered fact verification in action with multi-model consensus"
                    priority={true}
                  />
                </div>
                <h3 style={{ fontFamily: 'GT Super Display' }} className="text-xl md:text-2xl mb-4">
                  Verify Everything
                </h3>
                <p className="text-gray-400 mb-4">
                  Enter any factual claim or statement you want to verify. Our system accepts natural language input and processes it intelligently.
                </p>
              </div>
              
              {/* Right Column - Audit Everything */}
              <div className="md:pl-8 ">
                <div className="mb-8 ">
                  <Image 
                    src="/img2.png"
                    width={800} 
                    height={600} 
                    alt="Auditable verification certificates showing transparent AI decision-making process"
                    priority={true}
                  />
                </div>
                <h3 style={{ fontFamily: 'GT Super Display' }} className="text-xl md:text-2xl mb-4">
                  Audit Everything
                </h3>
                <p className="text-gray-400 mb-4">
                  We provide auditable certificates for every validated output so you can trust the data you&apos;re working with.
                </p>
              </div>
            </div>
            {/* Bottom Row - Multi-Model Verification */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8 md:mt-12 md:border-t border-white/50 md:gap-1  md:pt-8 md:pt-12">
            <div className="flex md:hidden justify-center items-center ">
                <Image 
                  src="/img3.png"
                  width={800} 
                  height={600} 
                  alt="Multi-model AI verification diagram showing how multiple models cross-check facts for accuracy"
                  priority={true}
                />
              </div>
              <div className='flex flex-col justify-end mb-20 '>
                <h3 style={{ fontFamily: 'GT Super Display' }} className="text-xl md:text-2xl mb-4">
                  Multi-Model Verification
                </h3>
                <p className="text-gray-400 mb-6">
                  Multiple specialized AI models independently verify each claim, working together to ensure high accuracy through consensus-based validation.
                </p>
                <Link
                  href="https://arxiv.org/abs/2411.06535"
                  target="_blank"
                  className="inline-flex w-fit items-center text-white border border-white/20 px-4 py-2 rounded-none text-sm hover:bg-white/50 transition-colors duration-200"
                >
                  Read our Research <ArrowRightIcon className="ml-2 h-4 w-4" />
                </Link>
              </div>
              <div className="hidden md:flex justify-center items-center border-l border-white/20">
                <Image 
                  src="/img3.png"
                  width={800} 
                  height={600} 
                  alt="Multi-model AI verification diagram showing how multiple models cross-check facts for accuracy"
                  priority={true}
                />
              </div>
            </div>
          </div>
        </section>


        {/* Footer Navigation */}
        <footer className="bg-black py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col md:flex-row justify-between items-center mb-4">
              <div className="mb-6 md:mb-0">
                <img src="/mira-logo.svg" alt="Mira Verify - Build Autonomous AI Applications" className="h-6 w-auto text-white" />
              </div>
              <div className="flex items-center space-x-4">
                <Link href="https://x.com/Mira_Network" className="text-gray-400 hover:text-white transition-colors">
                  <svg viewBox="0 0 24 24" aria-hidden="true" className="w-4 h-4 fill-current">
                    <g>
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
                    </g>
                  </svg>
                </Link>
                <span className="text-gray-600">/</span>
                <Link href="https://discord.com/invite/mira-network" className="text-gray-400 hover:text-white transition-colors">
                  discord
                </Link>
                <span className="text-gray-600">/</span>
                <Link href="https://mira.network/" className="text-gray-400 hover:text-white transition-colors">
                  website
                </Link>
              </div>
            </div>
            
            {/* Copyright and Privacy */}
            <div className="flex flex-col md:flex-row justify-between items-center pt-4 border-t border-white/20 text-sm text-gray-400">
              <div className="mb-2 md:mb-0">
                © {new Date().getFullYear()} Mira. All rights reserved.
              </div>
              <div className="flex items-center space-x-4">
                <Link href="/support" className="hover:text-white transition-colors">
                  Support
                </Link>
                <span className="text-gray-600">|</span>
                <Link href="/privacy" className="hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </footer>
      </main>
    </div>
  );
} 